/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Input
} from '../'

export const CurrencyInput = ({ id, label, value, onChange, disabled, bare, hasError, maxWidth, stepSize, minValue, className }) => (
  <div className={`slds-form-element ${className}`} style={maxWidth ? { maxWidth } : null}>
    {label &&
      <label className='slds-form-element__label' style={{ paddingLeft: '0', paddingRight: '0.25rem' }}>
        {label}
      </label>
    }
    <div className={`slds-form-element__control slds-input-has-fixed-addon ${className ? className : ''}`}>
      <span className='currency-input_form'>
        {bare
          ? <div className='slds-text-color_weak'>R</div>
          : <b>R</b>
        }
      </span>
      <Input
        id={id}
        type='number'
        stepSize={stepSize || '0.01'}
        minValue={minValue}
        value={value}
        onChange={onChange}
        disabled={disabled}
        bare={bare}
        hasError={hasError}
        currencyInput={true}
        rightAlignText={true}
        className='slds-size_1-of-1 currency-input_input'
      />
    </div>
  </div>
)

CurrencyInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  bare: PropTypes.bool,
  maxWidth: PropTypes.number,
  hasError: PropTypes.bool,
  stepSize: PropTypes.string,
  className: PropTypes.string
}

CurrencyInput.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/currency-input/index.js